"use strict";

// =====================================================
// ACCESO DE USUARIOS
//
// Archivo:
// src/fronend/seguridad/acceso/acceso.js
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosaccesos = [];

let usuariosAcceso = [];

let usuarioSeleccionadoAcceso = null;


// =====================================================
// ELEMENTOS
// =====================================================

let tbodyAccesos = null;

let btnNuevoRol = null;

let idUsuarioRol = null;


// =====================================================
// INICIALIZAR MÓDULO
// =====================================================

document.addEventListener(
    "DOMContentLoaded",
    function () {

        console.log(
            "Inicializando módulo de acceso..."
        );

        // =================================================
        // ELEMENTOS
        // =================================================

        tbodyAccesos =
            document.getElementById(
                "tbodyAccesos"
            );

        btnNuevoRol =
            document.getElementById(
                "btnNuevoRol"
            );

        idUsuarioRol =
            document.getElementById(
                "idUsuarioRol"
            );

        // =================================================
        // CARGAR DATOS
        // =================================================

        cargarAccesos();

        cargarUsuarios();

        // =================================================
        // MODAL NUEVO ROL
        // =================================================

        inicializarModalRol();

        // =================================================
        // GUARDAR
        // =================================================

        inicializarGuardarRol();

        // =================================================
        // EDITAR
        // =================================================

        inicializarEditarRol();

        // =================================================
        // ELIMINAR
        // =================================================

        inicializarEliminarRol();

        // =================================================
        // BUSQUEDA
        // =================================================

        inicializarBusqueda();

        console.log(
            "Módulo de acceso inicializado."
        );

    }
);


// =====================================================
// LISTAR ACCESOS
//
// URL EXISTENTE:
// GET /acceso/listar
// =====================================================

async function cargarAccesos() {

    try {

        const respuesta =
            await fetch(
                "/acceso/listar"
            );

        if (!respuesta.ok) {

            throw new Error(
                "Error HTTP: " +
                respuesta.status
            );

        }

        const tipoContenido =
            respuesta.headers.get(
                "content-type"
            );

        if (
            !tipoContenido ||
            !tipoContenido.includes(
                "application/json"
            )
        ) {

            const texto =
                await respuesta.text();

            console.error(
                "Respuesta recibida:",
                texto
            );

            throw new Error(
                "El servidor no devolvió JSON."
            );

        }

        const datos =
            await respuesta.json();

        console.log(
            "Registros de acceso:",
            datos
        );

        // =================================================
        // DETERMINAR FORMATO DE RESPUESTA
        // =================================================

        if (
            Array.isArray(datos)
        ) {

            registrosaccesos =
                datos;

        }

        else if (
            datos &&
            Array.isArray(
                datos.data
            )
        ) {

            registrosaccesos =
                datos.data;

        }

        else if (
            datos &&
            Array.isArray(
                datos.registros
            )
        ) {

            registrosaccesos =
                datos.registros;

        }

        else {

            registrosaccesos = [];

        }

        // =================================================
        // ACTUALIZAR CONTADORES
        // =================================================

        actualizarResumenAccesos();

        // =================================================
        // MOSTRAR TABLA
        // =================================================

        mostrarAccesos();

    }

    catch (error) {

        console.error(
            "Error al cargar accesos:",
            error
        );

        registrosaccesos = [];

        actualizarResumenAccesos();

        if (tbodyAccesos) {

            tbodyAccesos.innerHTML = `

                <tr>

                    <td
                        colspan="7"
                        class="text-center text-danger py-4">

                        <i
                            class="bi bi-exclamation-triangle me-2">
                        </i>

                        Error al cargar los registros.

                    </td>

                </tr>

            `;

        }

    }

}


// =====================================================
// ACTUALIZAR RESUMEN
//
// USUARIOS CON ACCESO:
// Cuenta usuarios únicos que tienen al menos
// un rol activo.
//
// ROLES ASIGNADOS:
// Cuenta todos los roles activos.
//
// NO SE CAMBIA NINGUNA URL.
// =====================================================

function actualizarResumenAccesos() {

    const totalUsuarios =
        document.getElementById(
            "totalUsuariosRol"
        );

    const totalRoles =
        document.getElementById(
            "totalRolesAsignados"
        );

    // =================================================
    // VALIDAR ARRAY
    // =================================================

    if (
        !Array.isArray(
            registrosaccesos
        )
    ) {

        registrosaccesos = [];

    }

    // =================================================
    // FILTRAR REGISTROS ACTIVOS
    // =================================================

    const registrosActivos =
        registrosaccesos.filter(
            function (
                registro
            ) {

                return String(
                    registro.ESTADO ?? ""
                )
                    .trim()
                    .toUpperCase()
                    === "A";

            }
        );

    // =================================================
    // CREAR CONJUNTO DE USUARIOS
    //
    // Set evita duplicados.
    //
    // Si:
    //
    // JUAN -> ADMINISTRADOR
    // JUAN -> RRHH
    //
    // Se cuenta solamente:
    //
    // JUAN = 1 usuario
    //
    // =================================================

    const usuariosUnicos =
        new Set();

    registrosActivos.forEach(
        function (
            registro
        ) {

            // =================================================
            // PRIMERA OPCIÓN:
            // IDUSUARIO
            // =================================================

            let identificadorUsuario =
                registro.IDUSUARIO ??
                registro.IdUsuario ??
                registro.idUsuario ??
                null;

            // =================================================
            // SEGUNDA OPCIÓN:
            // SI NO VIENE IDUSUARIO,
            // UTILIZAR NOMBRE DE USUARIO
            //
            // Esto evita que el contador quede en cero
            // si la vista todavía no devuelve IDUSUARIO.
            // =================================================

            if (
                identificadorUsuario === null ||
                identificadorUsuario === undefined ||
                String(
                    identificadorUsuario
                ).trim() === ""
            ) {

                identificadorUsuario =
                    registro.NOMBRE_USUARIO ??
                    registro.NOMBREUSUARIO ??
                    registro.USUARIO ??
                    null;

            }

            // =================================================
            // AGREGAR USUARIO
            // =================================================

            if (
                identificadorUsuario !== null &&
                identificadorUsuario !== undefined &&
                String(
                    identificadorUsuario
                ).trim() !== ""
            ) {

                usuariosUnicos.add(
                    String(
                        identificadorUsuario
                    )
                        .trim()
                        .toUpperCase()
                );

            }

        }
    );

    // =================================================
    // TOTAL USUARIOS CON ACCESO
    // =================================================

    if (
        totalUsuarios
    ) {

        totalUsuarios.textContent =
            usuariosUnicos.size;

    }

    // =================================================
    // TOTAL ROLES ASIGNADOS
    // =================================================

    if (
        totalRoles
    ) {

        totalRoles.textContent =
            registrosActivos.length;

    }

    // =================================================
    // DEBUG
    // =================================================

    console.log(
        "======================================"
    );

    console.log(
        "RESUMEN DE ACCESO"
    );

    console.log(
        "Usuarios con acceso:",
        usuariosUnicos.size
    );

    console.log(
        "Roles asignados:",
        registrosActivos.length
    );

    console.log(
        "Registros totales:",
        registrosaccesos.length
    );

    console.log(
        "Usuarios únicos:",
        Array.from(
            usuariosUnicos
        )
    );

    console.log(
        "======================================"
    );

}


// =====================================================
// MOSTRAR ACCESOS
// =====================================================

function mostrarAccesos() {

    if (!tbodyAccesos) {

        return;

    }

    tbodyAccesos.innerHTML = "";

    // =================================================
    // SIN REGISTROS
    // =================================================

    if (
        !Array.isArray(
            registrosaccesos
        ) ||
        registrosaccesos.length === 0
    ) {

        tbodyAccesos.innerHTML = `

            <tr>

                <td
                    colspan="7"
                    class="text-center text-muted py-4">

                    <i
                        class="bi bi-person-lock fs-3 d-block mb-2">
                    </i>

                    No hay registros de acceso

                </td>

            </tr>

        `;

        return;

    }

    // =================================================
    // RECORRER REGISTROS
    // =================================================

    registrosaccesos.forEach(
        function (
            registro,
            indice
        ) {

            const fila =
                document.createElement(
                    "tr"
                );

            // =================================================
            // ESTADO
            // =================================================

            let estadoHTML = "";

            if (
                String(
                    registro.ESTADO ?? ""
                )
                    .trim()
                    .toUpperCase()
                    === "A"
            ) {

                estadoHTML = `

                    <span
                        class="badge bg-success">

                        <i
                            class="bi bi-check-circle me-1">
                        </i>

                        Activo

                    </span>

                `;

            }

            else {

                estadoHTML = `

                    <span
                        class="badge bg-danger">

                        <i
                            class="bi bi-x-circle me-1">
                        </i>

                        Inactivo

                    </span>

                `;

            }

            // =================================================
            // FECHA
            // =================================================

            const fecha =
                formatearFecha(
                    registro.FECHAREGISTRO
                );

            // =================================================
            // NOMBRE USUARIO
            // =================================================

            const nombreUsuario =
                registro.NOMBRE_USUARIO ??
                registro.NOMBREUSUARIO ??
                registro.USUARIO ??
                "";

            // =================================================
            // ID ROL
            // =================================================

            const idRol =
                registro.IDROLES ??
                registro.IDROL ??
                "";

            // =================================================
            // ROL
            // =================================================

            const nombreRol =
                registro.NOMBREROL ??
                "";

            // =================================================
            // HTML FILA
            // =================================================

            fila.innerHTML = `

                <td
                    class="text-center">

                    ${indice + 1}

                </td>

                <td
                    class="text-center">

                    ${escapeHtml(
                        idRol
                    )}

                </td>

                <td>

                    <strong>

                        ${escapeHtml(
                            nombreUsuario
                        )}

                    </strong>

                </td>

                <td>

                    <span
                        class="badge bg-primary">

                        ${escapeHtml(
                            nombreRol
                        )}

                    </span>

                </td>

                <td
                    class="text-center">

                    ${fecha}

                </td>

                <td
                    class="text-center">

                    ${estadoHTML}

                </td>

                <td
                    class="text-center">

                    <div
                        class="btn-group"
                        role="group">

                        <!-- EDITAR -->

                        <button
                            type="button"
                            class="btn btn-sm btn-warning"
                            title="Editar acceso"
                            onclick="editarRol(${Number(
                                idRol
                            )})">

                            <i
                                class="bi bi-pencil-square">
                            </i>

                        </button>

                        <!-- ELIMINAR -->

                        <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            title="Eliminar acceso"
                            onclick="eliminarRol(${Number(
                                idRol
                            )})">

                            <i
                                class="bi bi-trash">
                            </i>

                        </button>

                    </div>

                </td>

            `;

            tbodyAccesos.appendChild(
                fila
            );

        }
    );

}


// =====================================================
// LISTAR USUARIOS
//
// URL EXISTENTE:
// GET /acceso/listarUsuarios
// =====================================================

async function cargarUsuarios() {

    try {

        const respuesta =
            await fetch(
                "/acceso/listarUsuarios"
            );

        if (!respuesta.ok) {

            throw new Error(
                "Error HTTP: " +
                respuesta.status
            );

        }

        const tipoContenido =
            respuesta.headers.get(
                "content-type"
            );

        if (
            !tipoContenido ||
            !tipoContenido.includes(
                "application/json"
            )
        ) {

            const texto =
                await respuesta.text();

            console.error(
                "Respuesta recibida:",
                texto
            );

            throw new Error(
                "El servidor no devolvió JSON."
            );

        }

        const datos =
            await respuesta.json();

        console.log(
            "Usuarios:",
            datos
        );

        // =================================================
        // DETERMINAR FORMATO
        // =================================================

        if (
            Array.isArray(datos)
        ) {

            usuariosAcceso =
                datos;

        }

        else if (
            datos &&
            Array.isArray(
                datos.data
            )
        ) {

            usuariosAcceso =
                datos.data;

        }

        else if (
            datos &&
            Array.isArray(
                datos.usuarios
            )
        ) {

            usuariosAcceso =
                datos.usuarios;

        }

        else {

            usuariosAcceso = [];

        }

        cargarUsuariosSelect();

    }

    catch (error) {

        console.error(
            "Error al cargar usuarios:",
            error
        );

        usuariosAcceso = [];

    }

}


// =====================================================
// CARGAR USUARIOS EN DROPLIST
// =====================================================

function cargarUsuariosSelect() {

    const select =
        document.getElementById(
            "idUsuarioRol"
        );

    if (!select) {

        return;

    }

    select.innerHTML = `

        <option value="">

            Seleccione un usuario

        </option>

    `;

    usuariosAcceso.forEach(
        function (
            usuario
        ) {

            const option =
                document.createElement(
                    "option"
                );

            option.value =
                usuario.IDUSUARIO;

            option.textContent =
                usuario.NOMBRE_USUARIO ??
                usuario.NOMBREUSUARIO ??
                usuario.USUARIO ??
                "";

            option.dataset.nombre =
                usuario.NOMBRE_USUARIO ??
                usuario.NOMBREUSUARIO ??
                usuario.USUARIO ??
                "";

            select.appendChild(
                option
            );

        }
    );

}


// =====================================================
// CAMBIAR USUARIO
// =====================================================

function actualizarDatosUsuarioAcceso() {

    const select =
        document.getElementById(
            "idUsuarioRol"
        );

    if (!select) {

        return;

    }

    const idUsuario =
        select.value;

    const mostrarId =
        document.getElementById(
            "mostrarIdUsuarioRol"
        );

    const mostrarNombre =
        document.getElementById(
            "mostrarNombreUsuarioRol"
        );

    const usuario =
        usuariosAcceso.find(
            function (
                item
            ) {

                return String(
                    item.IDUSUARIO
                ) === String(
                    idUsuario
                );

            }
        );

    usuarioSeleccionadoAcceso =
        usuario || null;

    if (mostrarId) {

        mostrarId.value =
            usuario
                ? usuario.IDUSUARIO
                : "";

    }

    if (mostrarNombre) {

        mostrarNombre.value =
            usuario
                ? (
                    usuario.NOMBRE_USUARIO ??
                    usuario.NOMBREUSUARIO ??
                    usuario.USUARIO ??
                    ""
                )
                : "";

    }

}


// =====================================================
// INICIALIZAR MODAL NUEVO
// =====================================================

function inicializarModalRol() {

    const select =
        document.getElementById(
            "idUsuarioRol"
        );

    if (select) {

        select.addEventListener(
            "change",
            actualizarDatosUsuarioAcceso
        );

    }

    if (btnNuevoRol) {

        btnNuevoRol.addEventListener(
            "click",
            function () {

                limpiarFormularioRol();

                const modalElemento =
                    document.getElementById(
                        "modalRol"
                    );

                if (!modalElemento) {

                    console.error(
                        "No existe #modalRol"
                    );

                    return;

                }

                const modal =
                    bootstrap.Modal.getOrCreateInstance(
                        modalElemento
                    );

                modal.show();

            }
        );

    }

}


// =====================================================
// LIMPIAR FORMULARIO
// =====================================================

function limpiarFormularioRol() {

    const form =
        document.getElementById(
            "formRol"
        );

    if (form) {

        form.reset();

    }

    const idRol =
        document.getElementById(
            "idRol"
        );

    if (idRol) {

        idRol.value = "";

    }

    const mostrarId =
        document.getElementById(
            "mostrarIdUsuarioRol"
        );

    if (mostrarId) {

        mostrarId.value = "";

    }

    const mostrarNombre =
        document.getElementById(
            "mostrarNombreUsuarioRol"
        );

    if (mostrarNombre) {

        mostrarNombre.value = "";

    }

    const fecha =
        document.getElementById(
            "fechaRegistroRol"
        );

    if (fecha) {

        fecha.value =
            obtenerFechaActual();

    }

    const estado =
        document.getElementById(
            "estadoRol"
        );

    if (estado) {

        estado.value =
            "A";

    }

    usuarioSeleccionadoAcceso =
        null;

}


// =====================================================
// GUARDAR
//
// URL EXISTENTE:
// POST /acceso/guardar
// =====================================================

function inicializarGuardarRol() {

    const form =
        document.getElementById(
            "formRol"
        );

    if (!form) {

        return;

    }

    form.addEventListener(
        "submit",
        async function (
            event
        ) {

            event.preventDefault();

            const idUsuario =
                document.getElementById(
                    "idUsuarioRol"
                )?.value;

            const nombreRol =
                document.getElementById(
                    "nombreRol"
                )?.value;

            const fechaRegistro =
                document.getElementById(
                    "fechaRegistroRol"
                )?.value;

            const estado =
                document.getElementById(
                    "estadoRol"
                )?.value;

            if (!idUsuario) {

                alert(
                    "Seleccione un usuario."
                );

                return;

            }

            if (!nombreRol) {

                alert(
                    "Seleccione un rol."
                );

                return;

            }

            try {

                const respuesta =
                    await fetch(
                        "/acceso/guardar",
                        {

                            method:
                                "POST",

                            headers: {

                                "Content-Type":
                                    "application/json"

                            },

                            body:
                                JSON.stringify({

                                    NOMBREROL:
                                        nombreRol,

                                    IDUSUARIO:
                                        Number(
                                            idUsuario
                                        ),

                                    ESTADO:
                                        estado || "A",

                                    FECHAREGISTRO:
                                        fechaRegistro

                                })

                        }
                    );

                const tipoContenido =
                    respuesta.headers.get(
                        "content-type"
                    );

                if (
                    !tipoContenido ||
                    !tipoContenido.includes(
                        "application/json"
                    )
                ) {

                    const texto =
                        await respuesta.text();

                    console.error(
                        texto
                    );

                    throw new Error(
                        "El servidor no devolvió JSON."
                    );

                }

                const resultado =
                    await respuesta.json();

                if (!respuesta.ok) {

                    throw new Error(
                        resultado.mensaje ||
                        resultado.error ||
                        "No se pudo guardar el acceso."
                    );

                }

                alert(
                    resultado.mensaje ||
                    "Acceso guardado correctamente."
                );

                const modalElemento =
                    document.getElementById(
                        "modalRol"
                    );

                if (modalElemento) {

                    const modal =
                        bootstrap.Modal.getInstance(
                            modalElemento
                        );

                    if (modal) {

                        modal.hide();

                    }

                }

                await cargarAccesos();

            }

            catch (error) {

                console.error(
                    "Error guardando acceso:",
                    error
                );

                alert(
                    error.message ||
                    "Error al guardar el acceso."
                );

            }

        }
    );

}


// =====================================================
// EDITAR ROL
//
// Busca el registro y abre:
// #modalEditarRol
// =====================================================

function editarRol(
    idRol
) {

    console.log(
        "Editar rol:",
        idRol
    );

    const registro =
        registrosaccesos.find(
            function (
                item
            ) {

                return Number(
                    item.IDROLES ??
                    item.IDROL
                ) === Number(
                    idRol
                );

            }
        );

    if (!registro) {

        console.error(
            "Registro no encontrado:",
            idRol
        );

        alert(
            "No se encontró el registro de acceso."
        );

        return;

    }

    console.log(
        "Registro seleccionado:",
        registro
    );

    const idRolEditar =
        document.getElementById(
            "idRolEditar"
        );

    const idRolMostrarEditar =
        document.getElementById(
            "idRolMostrarEditar"
        );

    const idUsuarioEditar =
        document.getElementById(
            "idUsuarioEditarRol"
        );

    const nombreUsuarioEditar =
        document.getElementById(
            "nombreUsuarioEditarRol"
        );

    const nombreRolEditar =
        document.getElementById(
            "nombreRolEditar"
        );

    const fechaRegistroEditar =
        document.getElementById(
            "fechaRegistroEditarRol"
        );

    const estadoEditar =
        document.getElementById(
            "estadoEditarRol"
        );

    const idRolValor =
        registro.IDROLES ??
        registro.IDROL ??
        "";

    if (idRolEditar) {

        idRolEditar.value =
            idRolValor;

    }

    if (idRolMostrarEditar) {

        idRolMostrarEditar.value =
            idRolValor;

    }

    let idUsuario =
        registro.IDUSUARIO ??
        "";

    const nombreUsuario =
        registro.NOMBRE_USUARIO ??
        registro.NOMBREUSUARIO ??
        registro.USUARIO ??
        "";

    // =================================================
    // SI NO TRAE IDUSUARIO
    // BUSCARLO POR NOMBRE
    // =================================================

    if (
        !idUsuario &&
        nombreUsuario &&
        Array.isArray(
            usuariosAcceso
        )
    ) {

        const usuarioEncontrado =
            usuariosAcceso.find(
                function (
                    usuario
                ) {

                    const nombre =
                        usuario.NOMBRE_USUARIO ??
                        usuario.NOMBREUSUARIO ??
                        usuario.USUARIO ??
                        "";

                    return (
                        String(
                            nombre
                        )
                            .trim()
                            .toLowerCase()
                        ===
                        String(
                            nombreUsuario
                        )
                            .trim()
                            .toLowerCase()
                    );

                }
            );

        if (usuarioEncontrado) {

            idUsuario =
                usuarioEncontrado.IDUSUARIO;

        }

    }

    if (idUsuarioEditar) {

        idUsuarioEditar.value =
            idUsuario || "";

    }

    if (nombreUsuarioEditar) {

        nombreUsuarioEditar.value =
            nombreUsuario;

    }

    if (nombreRolEditar) {

        nombreRolEditar.value =
            registro.NOMBREROL ?? "";

    }

    if (fechaRegistroEditar) {

        fechaRegistroEditar.value =
            convertirFechaInput(
                registro.FECHAREGISTRO
            );

    }

    if (estadoEditar) {

        estadoEditar.value =
            registro.ESTADO ?? "A";

    }

    const modalElemento =
        document.getElementById(
            "modalEditarRol"
        );

    if (!modalElemento) {

        console.error(
            "No existe el modal #modalEditarRol."
        );

        alert(
            "No se encontró el modal de edición."
        );

        return;

    }

    const modal =
        bootstrap.Modal.getOrCreateInstance(
            modalElemento
        );

    modal.show();

}


// =====================================================
// INICIALIZAR ACTUALIZACIÓN DEL ROL
//
// URL:
// PUT /acceso/actualizar
//
// Ejecuta:
// SP_ROLES_U
// =====================================================

function inicializarEditarRol() {

    const form =
        document.getElementById(
            "formEditarRol"
        );

    if (!form) {

        console.warn(
            "No existe #formEditarRol"
        );

        return;

    }

    form.addEventListener(
        "submit",
        async function (
            event
        ) {

            event.preventDefault();

            const idRol =
                document.getElementById(
                    "idRolEditar"
                )?.value;

            const nombreRol =
                document.getElementById(
                    "nombreRolEditar"
                )?.value
                ?.trim();

            const fechaRegistro =
                document.getElementById(
                    "fechaRegistroEditarRol"
                )?.value;

            const estado =
                document.getElementById(
                    "estadoEditarRol"
                )?.value;

            console.log(
                "Datos para actualizar:",
                {
                    IDROLES: idRol,
                    NOMBREROL: nombreRol,
                    ESTADO: estado,
                    FECHAREGISTRO:
                        fechaRegistro
                }
            );

            if (
                !idRol ||
                isNaN(
                    Number(idRol)
                )
            ) {

                alert(
                    "El ID del rol no es válido."
                );

                return;

            }

            if (!nombreRol) {

                alert(
                    "Ingrese el nombre del rol."
                );

                return;

            }

            if (!fechaRegistro) {

                alert(
                    "Seleccione la fecha de registro."
                );

                return;

            }

            if (!estado) {

                alert(
                    "Seleccione el estado."
                );

                return;

            }

            try {

                const respuesta =
                    await fetch(
                        "/acceso/actualizar",
                        {

                            method:
                                "PUT",

                            headers: {

                                "Content-Type":
                                    "application/json"

                            },

                            body:
                                JSON.stringify({

                                    IDROLES:
                                        Number(
                                            idRol
                                        ),

                                    NOMBREROL:
                                        nombreRol,

                                    ESTADO:
                                        estado,

                                    FECHAREGISTRO:
                                        fechaRegistro

                                })

                        }
                    );

                const tipoContenido =
                    respuesta.headers.get(
                        "content-type"
                    );

                if (
                    !tipoContenido ||
                    !tipoContenido.includes(
                        "application/json"
                    )
                ) {

                    const texto =
                        await respuesta.text();

                    console.error(
                        "Respuesta recibida:",
                        texto
                    );

                    throw new Error(
                        "El servidor no devolvió JSON."
                    );

                }

                const resultado =
                    await respuesta.json();

                if (!respuesta.ok) {

                    throw new Error(
                        resultado.mensaje ||
                        resultado.error ||
                        "No se pudo actualizar el rol."
                    );

                }

                alert(
                    resultado.mensaje ||
                    "Rol actualizado correctamente."
                );

                const modalElemento =
                    document.getElementById(
                        "modalEditarRol"
                    );

                if (modalElemento) {

                    const modal =
                        bootstrap.Modal.getInstance(
                            modalElemento
                        );

                    if (modal) {

                        modal.hide();

                    }

                }

                await cargarAccesos();

            }

            catch (error) {

                console.error(
                    "Error al actualizar rol:",
                    error
                );

                alert(
                    error.message ||
                    "Error al actualizar el rol."
                );

            }

        }
    );

}


// =====================================================
// ELIMINAR ROL
//
// URL:
// DELETE /acceso/eliminar
// =====================================================

function eliminarRol(
    idRol
) {

    console.log(
        "Eliminar rol:",
        idRol
    );

    const idEliminar =
        document.getElementById(
            "idRolEliminar"
        );

    if (idEliminar) {

        idEliminar.value =
            idRol;

    }

    const mostrarIdEliminar =
        document.getElementById(
            "mostrarIdRolEliminar"
        );

    if (mostrarIdEliminar) {

        mostrarIdEliminar.value =
            idRol;

    }

    // =================================================
    // BUSCAR REGISTRO
    // =================================================

    const registro =
        registrosaccesos.find(
            function (
                item
            ) {

                return Number(
                    item.IDROLES ??
                    item.IDROL
                ) === Number(
                    idRol
                );

            }
        );

    // =================================================
    // MOSTRAR DATOS EN MODAL
    // =================================================

    if (registro) {

        const nombreUsuarioEliminar =
            document.getElementById(
                "nombreUsuarioEliminarRol"
            );

        const nombreRolEliminar =
            document.getElementById(
                "nombreRolEliminar"
            );

        if (nombreUsuarioEliminar) {

            nombreUsuarioEliminar.value =
                registro.NOMBRE_USUARIO ??
                registro.NOMBREUSUARIO ??
                registro.USUARIO ??
                "";

        }

        if (nombreRolEliminar) {

            nombreRolEliminar.value =
                registro.NOMBREROL ??
                "";

        }

    }

    // =================================================
    // ABRIR MODAL
    // =================================================

    const modalElemento =
        document.getElementById(
            "modalEliminarRol"
        );

    if (!modalElemento) {

        console.error(
            "No existe #modalEliminarRol."
        );

        const confirmar =
            confirm(
                "¿Está seguro de eliminar este rol?"
            );

        if (confirmar) {

            ejecutarEliminarRol(
                idRol
            );

        }

        return;

    }

    const modal =
        bootstrap.Modal.getOrCreateInstance(
            modalElemento
        );

    modal.show();

}


// =====================================================
// INICIALIZAR ELIMINACIÓN
// =====================================================

function inicializarEliminarRol() {

    const form =
        document.getElementById(
            "formEliminarRol"
        );

    if (form) {

        form.addEventListener(
            "submit",
            async function (
                event
            ) {

                event.preventDefault();

                const idEliminar =
                    document.getElementById(
                        "idRolEliminar"
                    )?.value;

                if (
                    !idEliminar ||
                    isNaN(
                        Number(
                            idEliminar
                        )
                    )
                ) {

                    alert(
                        "El ID del rol no es válido."
                    );

                    return;

                }

                await ejecutarEliminarRol(
                    Number(
                        idEliminar
                    )
                );

            }
        );

    }

    const btnConfirmar =
        document.getElementById(
            "btnConfirmarEliminarRol"
        );

    if (btnConfirmar) {

        btnConfirmar.addEventListener(
            "click",
            async function () {

                const idEliminar =
                    document.getElementById(
                        "idRolEliminar"
                    )?.value;

                if (
                    !idEliminar ||
                    isNaN(
                        Number(
                            idEliminar
                        )
                    )
                ) {

                    alert(
                        "El ID del rol no es válido."
                    );

                    return;

                }

                await ejecutarEliminarRol(
                    Number(
                        idEliminar
                    )
                );

            }
        );

    }

}


// =====================================================
// EJECUTAR ELIMINACIÓN
//
// URL:
// DELETE /acceso/eliminar
//
// Ejecuta:
// SP_ROLES_D
// =====================================================

async function ejecutarEliminarRol(
    idRol
) {

    try {

        console.log(
            "Eliminando rol:",
            idRol
        );

        if (
            !idRol ||
            isNaN(
                Number(
                    idRol
                )
            )
        ) {

            alert(
                "El ID del rol no es válido."
            );

            return;

        }

        const respuesta =
            await fetch(
                "/acceso/eliminar",
                {

                    method:
                        "DELETE",

                    headers: {

                        "Content-Type":
                            "application/json"

                    },

                    body:
                        JSON.stringify({

                            IDROLES:
                                Number(
                                    idRol
                                )

                        })

                }
            );

        const tipoContenido =
            respuesta.headers.get(
                "content-type"
            );

        if (
            !tipoContenido ||
            !tipoContenido.includes(
                "application/json"
            )
        ) {

            const texto =
                await respuesta.text();

            console.error(
                "Respuesta recibida:",
                texto
            );

            throw new Error(
                "El servidor no devolvió JSON."
            );

        }

        const resultado =
            await respuesta.json();

        console.log(
            "Resultado eliminación:",
            resultado
        );

        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                resultado.error ||
                "No se pudo eliminar el rol."
            );

        }

        alert(
            resultado.mensaje ||
            "Rol eliminado correctamente."
        );

        const modalElemento =
            document.getElementById(
                "modalEliminarRol"
            );

        if (modalElemento) {

            const modal =
                bootstrap.Modal.getInstance(
                    modalElemento
                );

            if (modal) {

                modal.hide();

            }

        }

        const idEliminar =
            document.getElementById(
                "idRolEliminar"
            );

        if (idEliminar) {

            idEliminar.value =
                "";

        }

        await cargarAccesos();

    }

    catch (error) {

        console.error(
            "Error al eliminar rol:",
            error
        );

        alert(
            error.message ||
            "Error al eliminar el rol."
        );

    }

}


// =====================================================
// BUSQUEDA
// =====================================================

function inicializarBusqueda() {

    const input =
        document.getElementById(
            "buscarRol"
        );

    const btnLimpiar =
        document.getElementById(
            "btnLimpiarBusqueda"
        );

    if (input) {

        input.addEventListener(
            "input",
            function () {

                const texto =
                    input.value
                        .trim()
                        .toLowerCase();

                const filas =
                    tbodyAccesos
                        ?.querySelectorAll(
                            "tr"
                        );

                if (!filas) {

                    return;

                }

                filas.forEach(
                    function (
                        fila
                    ) {

                        const contenido =
                            fila.textContent
                                .toLowerCase();

                        fila.style.display =
                            contenido.includes(
                                texto
                            )
                                ? ""
                                : "none";

                    }
                );

            }
        );

    }

    if (btnLimpiar) {

        btnLimpiar.addEventListener(
            "click",
            function () {

                if (input) {

                    input.value = "";

                    input.dispatchEvent(
                        new Event(
                            "input"
                        )
                    );

                }

            }
        );

    }

}


// =====================================================
// FORMATEAR FECHA
// =====================================================

function formatearFecha(
    fecha
) {

    if (!fecha) {

        return "";

    }

    try {

        const fechaObj =
            new Date(
                fecha
            );

        if (
            Number.isNaN(
                fechaObj.getTime()
            )
        ) {

            return fecha;

        }

        return fechaObj.toLocaleDateString(
            "es-GT",
            {

                year:
                    "numeric",

                month:
                    "2-digit",

                day:
                    "2-digit"

            }
        );

    }

    catch (
        error
    ) {

        return fecha;

    }

}


// =====================================================
// CONVERTIR FECHA PARA INPUT DATE
// =====================================================

function convertirFechaInput(
    fecha
) {

    if (!fecha) {

        return "";

    }

    // =================================================
    // YA VIENE YYYY-MM-DD
    // =================================================

    if (
        typeof fecha === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(
            fecha
        )
    ) {

        return fecha;

    }

    // =================================================
    // FECHA SQL SERVER
    // =================================================

    if (
        typeof fecha === "string" &&
        fecha.length >= 10
    ) {

        const fechaTexto =
            fecha.substring(
                0,
                10
            );

        if (
            /^\d{4}-\d{2}-\d{2}$/.test(
                fechaTexto
            )
        ) {

            return fechaTexto;

        }

    }

    // =================================================
    // DATE
    // =================================================

    try {

        const fechaObj =
            new Date(
                fecha
            );

        if (
            Number.isNaN(
                fechaObj.getTime()
            )
        ) {

            return "";

        }

        const año =
            fechaObj.getFullYear();

        const mes =
            String(
                fechaObj.getMonth() + 1
            ).padStart(
                2,
                "0"
            );

        const dia =
            String(
                fechaObj.getDate()
            ).padStart(
                2,
                "0"
            );

        return (
            año +
            "-" +
            mes +
            "-" +
            dia
        );

    }

    catch (
        error
    ) {

        return "";

    }

}


// =====================================================
// FECHA ACTUAL
// =====================================================

function obtenerFechaActual() {

    const fecha =
        new Date();

    const año =
        fecha.getFullYear();

    const mes =
        String(
            fecha.getMonth() + 1
        ).padStart(
            2,
            "0"
        );

    const dia =
        String(
            fecha.getDate()
        ).padStart(
            2,
            "0"
        );

    return (
        año +
        "-" +
        mes +
        "-" +
        dia
    );

}


// =====================================================
// ESCAPAR HTML
// =====================================================

function escapeHtml(
    valor
) {

    if (
        valor === null ||
        valor === undefined
    ) {

        return "";

    }

    return String(
        valor
    )
        .replace(
            /&/g,
            "&amp;"
        )
        .replace(
            /</g,
            "&lt;"
        )
        .replace(
            />/g,
            "&gt;"
        )
        .replace(
            /"/g,
            "&quot;"
        )
        .replace(
            /'/g,
            "&#039;"
        );

}


// =====================================================
// FUNCIONES GLOBALES
// PARA LOS onclick DEL HTML
// =====================================================

window.editarRol =
    editarRol;

window.eliminarRol =
    eliminarRol;